<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">User Feedback</p>

    <section class="call-stats__items" v-if="!loading">
      <p v-if="hasWhitelist()">Select an establishment to see stats</p>
      <b-form-select v-if="!hasWhitelist()" v-model="activeChart" class="mb-2" :class="{'disabled': loading}">
        <b-form-select-option value="average">Average Feedback</b-form-select-option>
        <b-form-select-option value="total">Total Feedback</b-form-select-option>
      </b-form-select>

      <section>
        <div v-if="prisonStats && !hasWhitelist()" class="row text-center">
          <p class="col-6 brand-color font-weight-bold mb-0">Average Feedback rating for {{filters.prisonId ? 'establishment' : 'group'}}:
            <b>{{prisonStats.average_feedback_rating ? prisonStats.average_feedback_rating.toFixed(1) : 0}}</b>
          </p>
          <p class="col-6 brand-color font-weight-bold mb-0">Total Feedback rating for establishment: <b>{{prisonStats.total_feedback}}</b></p>
        </div>
      </section>

      <section class="mt-4">
        <section v-if="stats">
          <div v-if="!hasWhitelist()">
            <apex-chart :key="1 + filters.prisonId" class="mx-auto" v-if="activeChart === 'average'"
                        :title="'Leaderboard: Average Feedback'"
                        :y-annotate="chart.average.annotate"
                        y-title="Average feedback number" x-title="Prisons" :series="[chart.average.series]"></apex-chart>

            <apex-chart :key="2 + filters.prisonId" class="mx-auto" v-if="activeChart === 'total'"
                        :y-annotate="chart.total.annotate"
                        :title="'Leaderboard: Total feedback'" y-title="Total feedback number"
                        x-title="Prisons" :series="[chart.total.series]"></apex-chart>
          </div>
          <visitor-feedback-table :filters="filters"></visitor-feedback-table>
        </section>
        <p v-if="!stats && !hasWhitelist()">Please select a establishment to see leaderboard stats</p>
      </section>

    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import BiStatsService from '../../../services/BiStatsService';
import HelperService from '../../../services/HelperService';
import ApexChart from '../ApexChart.vue';
import VisitorFeedbackTable from '../../tables/vistorFeedbackTable/VisitorFeedbackTable.vue';

export default {
  components: {
    ApexChart,
    VisitorFeedbackTable,
  },
  props: {
    filters: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      activeChart: 'average',
      stats: null,
      prisonStats: null,
      chart: {
        total: {
          series: {
            name: '',
            data: [],
          },
          annotate: {
            text: '',
            value: null,
          },
        },
        average: {
          series: {
            name: '',
            data: [],
          },
          annotate: {
            text: '',
            value: null,
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      compareMode: state => state.stats.compareMode,
      user: state => state.auth.user,
    }),
  },
  watch: {
    filters: {
      handler() {
        this.getFeedbackStats();
      },
      deep: true,
    },
  },
  mounted() {
    this.getFeedbackStats();
  },
  methods: {
    getFeedbackStats() {
      this.loading = true;
      this.stats = null; // reset old stats
      this.prisonStats = null;

      const promises = [this.getVisitorFeedbackStats()];

      if (this.filters.prisonId) {
        promises.push(this.getVisitorFeedbackLeaderboard());
      }

      Promise.all(promises).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
    },
    getVisitorFeedbackStats() {
      return BiStatsService.getVisitorFeedback(this.filters).then(res => {
        this.prisonStats = res.data;
      }).catch(err => {
        console.log('could not get feedback stats', err);
        this.$toast.error('Could not get user feedback stats, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getVisitorFeedbackLeaderboard() {
      return BiStatsService.getVisitorFeedbackLeaderboard(this.filters).then(res => {
        this.stats = res.data.prisons;
        this.setUpChartData(this.stats, 'average', 'average_feedback_rating');
        this.setUpChartData(this.stats, 'total', 'total_feedback');
      }).catch(err => {
        console.log('could not get feedback leaderboard stats', err);
        this.$toast.error('Could not get user feedback leaderboard stats, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    setUpChartData(prisons, type, propName) {
      this.chart[type].series.data = []; // reset data

      const topPrisons = prisons.length > 5 ? this.getTopPrisons(prisons, 5, propName) : prisons;
      topPrisons.forEach(prison => {
        this.chart[type].series.data.push({
          x: prison.prison_name,
          y: prison[propName].toFixed(1),
        });
      });
    },
    getTopPrisons(prisons, amount, propName) {
      const sortedPrisons = [];

      prisons.sort((a, b) => b[propName] - a[propName]);

      prisons.forEach((reason, index) => {
        if (index <= amount - 1) {
          sortedPrisons.push(prisons[index]);
        }
      });

      if (!sortedPrisons.find(prison => prison.prisonId === this.filters.prisonId)) {
        const found = prisons.find(prison => prison.prison_id === this.filters.prisonId);
        sortedPrisons.push(found);
      }

      return sortedPrisons;
    },
    hasWhitelist() {
      return this.user.prisons_whitelist && this.user.prisons_whitelist.length > 0
    },
  },
};
</script>
